import styled from "styled-components/macro";
import { themeVariables } from "../../../../themeVariables";
import { focusVisible, focusVisibleInset, buttonReset } from "../../../../styles/a11y";

export const StoryBibleMenuContainer = styled.div`
  padding: 4px 16px;
  color: var(--grey-0);
  font-weight: 500;
  margin-top: 4px;

  .inner-container {
    --story-bible-icon-column: 22px;
    padding: 12px 12px 6px 12px;
    border: 2px solid var(--primary-cta-transparent);
    border-radius: 20px;
    overflow: hidden;
    transition: all 0.3s linear;

    &.collapse {
      padding: 12px;
    }

    .header {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;

      .heading-row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        min-width: 0;
        flex: 1;
      }

      button.use-component-styles.sections-chevron {
        ${buttonReset}
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        margin-right: 2px;
        margin-left: -4px;
        border: none;
        outline: none;
        border-radius: 5px;
        background-color: transparent;

        .chevron-icon {
          width: 18px;
          height: 18px;
          transition: transform 150ms ease-in-out;

          path {
            fill: var(--grey-0);
          }

          rect {
            stroke: none;
          }

          &.expanded {
            transform: rotate(90deg);
          }
        }

        &:hover {
          background-color: ${themeVariables.listElementHover};
        }

        &:focus,
        &:focus-visible {
          outline: none;
          background-color: transparent;
        }

        &:hover:focus,
        &:hover:focus-visible {
          background-color: ${themeVariables.listElementHover};
        }
      }

      button:not(.use-component-styles).heading {
        color: var(--gray-0) !important;
        background: none !important;
        padding: 0 !important;
        margin-top: 0 !important;
        border: none;
        cursor: pointer;
        font: inherit;
        ${focusVisible}
        border-radius: 6px;
      }

      .heading {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
        flex: 1;

        &.series {
          margin-left: -2px;
        }

        .icon {
          svg {
            path {
              fill: ${themeVariables.grey0};
            }

            rect {
              stroke: ${themeVariables.gray0};
            }

            rect:first-child {
              stroke: none;
            }
          }
        }

        &.highlight {
          color: var(--primary-cta-high-contrast);

          .icon {
            svg {
              path {
                fill: var(--primary-cta-high-contrast);
              }
            }
          }
        }

        .title {
          margin-left: 7px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-wrap: nowrap;
          line-height: 1.3;
        }

        &.series .title {
          margin-left: 4px;
        }
      }
    }

    .heading,
    .section-heading {
      transition: transform 0.1s linear;

      &:hover {
        cursor: pointer;
      }

      &:active {
        transform: scale(0.98);
      }
    }

    .subheader {
      margin-top: 8px;
      color: var(--grey-2);
      font-size: 12px;
      line-height: 1.3;
    }

    .sections {
      margin-top: 4px;
      transition: max-height 0.25s linear;
      max-height: 500px;

      #story-bible-menu-sections {
        list-style: none;
        padding: 0;
        margin: 0;
        padding-left: calc(var(--story-bible-icon-column) - 4px);
      }

      &.collapse {
        max-height: 0 !important;
        margin: 0 !important;
        clip: rect(0, 0, 0, 0);
        overflow: hidden;
        transition: max-height 0.25s ease-out, margin 0.25s ease-out;
      }

      .section {
        margin-left: 0;
        border-radius: 6px;
        transition: background-color 0.2s;

        &.series {
          margin-left: 0;
        }

        &.in-view {
          background-color: ${themeVariables.selectedElementBackground};
          color: ${themeVariables.selectedElementText};

          svg {
            path {
              fill: ${themeVariables.selectedElementText};
            }

            rect {
              stroke: ${themeVariables.selectedElementText};
            }
          }

          &:hover {
            background-color: ${themeVariables.selectedElementBackground};
          }
        }

        &:hover {
          background-color: ${themeVariables.listElementHover};
        }

        a {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          padding: 4px;
          cursor: pointer;
          color: inherit;
          text-decoration: none;
          border-radius: 6px;
          ${focusVisibleInset}

          .section-icon {
            width: 26.2px;
            height: 26.2px;
            margin-right: 4px;
            svg {
              width: 26.2px;
              height: 26.2px;
            }
          }

          .section-title {
            overflow: hidden;
            text-overflow: ellipsis;
            text-wrap: nowrap;
            height: 26.2px;
            line-height: 1.55;
          }
        }
      }

      .section-type-separator {
        border: 1px solid var(--primary-cta-transparent);
        margin: 10px -14px 15px -14px;
      }

      .section-heading {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        gap: 7px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 4px;
        max-width: 100px;
        border-radius: 6px;
        ${focusVisible}
      }
    }
  }

  svg {
    path {
      fill: var(--grey-0);
    }

    rect {
      stroke: var(--grey-0);
    }
  }
`;
